import type { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { cn } from "@/lib/utils";

import useAuthStore from "@/store/useAuthStore";
import useSidebarStore from "@/store/useSidebarStore";

import Sidebar from "./Sidebar";
import Toolbar from "./Toolbar";

type UserWrapperProps = {
  className?: string;
};
export default function UserWrapper({ children }: PropsWithChildren<UserWrapperProps>) {
  const { isOpen } = useSidebarStore();
  const { isAuthorized } = useAuthStore();

  if (!isAuthorized) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="flex w-full">
      <Sidebar />
      <div className={cn("flex w-full min-w-0 flex-col", isOpen ? "md:pl-[286px]" : "md:pl-[81px]")}>
        <Toolbar />
        <div className="mx-4 mt-6 flex flex-1 flex-col md:mx-8">{children}</div>
      </div>
    </div>
  );
}
